// BEM connect js & css
require('./modules/script');
// require ('./bem.js');
require('./modules/scrollUp');

import fancybox from './modules/fancybox';
import aboutCompany from './components/about-company';
import projectSliderList from './components/project-slider-list';
import articles from './components/articles';
import mainSlider from './components/main-slider';
import menu from './components/menu';
import form from './components/form';
import projects from './components/projects';
import services from './components/services';
import gallery from './components/gallery';
import select2 from './components/select2';

export default el => {
  'use strict';
    /**
     * update i-ua_js_ class
     */
    $('html').removeClass('i-ua_js_no').addClass('i-ua_js_yes');

    if ($('.contacts__map').length && window.innerWidth > 767) {
      require.ensure([], require => {
        require('./modules/ymap');
      });
    }

    require.ensure([], require => {
      require('./modules/popup');
    });


    if ($('.flipster-objects').length) {
      require.ensure([], require => {
        require('./modules/flipster-config');
      });
    }

    fancybox('.fancybox');

    if ($('.about-company').length) {
      aboutCompany();
    }

    if ($('.project-card__slider-list').length) {
      projectSliderList();
    }

    articles();

    if ($('.main-slider').length) {
      mainSlider();
    }

    if ($('.menu').length) {
      menu();
    }

    if ($('.form').length) {
      form();
    }

    if ($('.projects__slider').length) {
      projects();
    }

    if ($('.services__slider').length) {
      services();
    }

    if ($('.gallery').length) {
      gallery();
    }

    if ($('.form select').length) {
      select2();
    }

    if ($('.breadcrumbs').length) {
      $('.breadcrumbs a').hover(function () {
          $(this).removeClass('reset-animation');
          $(this).addClass('anim')
        }, function () {
          $(this).removeClass('anim');
          $(this).addClass('reset-animation')
        }
      );
    }

    $('.collapse-button').each(function () {
      const targetSelector = $(this).data('target');
      const targetEl = $(this).closest(targetSelector);

      const targetText = $(this).data('text');
      const textNode = $(this).children(':first');
      const defaultText = textNode.text();

      $(this).click(function () {
        $(this).toggleClass('active');
        targetEl.toggleClass('active');

        if (!targetText) return;

        const textContent = textNode.text();
        const textIsSame = defaultText.trim().toLowerCase() === textContent.trim().toLowerCase();

        textNode.text(textIsSame ? targetText : defaultText)
      })
    });

    // Hide collapse-button if <p> length < 2
    $('.stages__item').each(function () {
      const notEnoughText = $(this).find('.stages__content').children().length < 2;
      const contentIsEmpty = $(this).find('.stages__content').children().length === 0;
      const title = $(this).find('.stages__title');

      if (contentIsEmpty && title.height() < 38) {
        title.addClass('center')
      }

      if (notEnoughText) {
        $(this).find('.collapse-button').remove();
      }
    })
}



// WEBPACK FOOTER //
// ./templates/bazis/assets/js/jQueryApplication/common.js